import * as React from 'react'

import Box from '@mui/material/Box'
import { Select } from '@workwave-tidal/core/components'
import FormHelperText from '@mui/material/FormHelperText'

import { useData, useHandlers } from './hooks'
import { BestContactMethodOptionsType } from './hooks/useData'
import { ScrollToErrorMarker } from '@user/components/Formik/ScrollToErrorMarker'
import { DensityType } from '../../../typings'

type Props = {
  required: boolean
  show: boolean
  name: string
  density: DensityType
}

export function BestContactMethodSelect(props: Props) {
  const { required, show, name, density } = props
  const {
    options,
    getOptionLabel,
    getId,
    initialOption,
    isSubmitting,
    helperText,
    showError,
  } = useData({ required, name })
  const { handelChange } = useHandlers({ name })
  return show ? (
    <Box>
      <Select<BestContactMethodOptionsType>
        density={density}
        disabled={isSubmitting}
        required={required}
        getLabel={getOptionLabel}
        error={showError}
        getId={getId}
        items={options}
        onChange={handelChange}
        value={initialOption}
        label={'Best Contact Method'}
        optionMode={'normal'}
        testId="best-contact-method-select"
      />
      {showError && (
        <FormHelperText sx={{ ml: 1 }} error>
          {helperText}
        </FormHelperText>
      )}
      <ScrollToErrorMarker fieldName={name} />
    </Box>
  ) : null
}
